import Mixin from 'mixmatch';

export default class Find extends Mixin {
  async find(id, params = {}) {
    const options = {
      method: 'GET',
      // @ts-ignore
      path: this.member(id),
      qs: params,
    };

    // @ts-ignore
    const body = await this.call(options);
    // @ts-ignore
    return JSON.parse(body)[this.resourceName];
  }
}
